// extracted by mini-css-extract-plugin
export default {"rightTop":"rightTop-nyim4","icon":"icon-jROwo","redDot":"redDot-XmWll"};